import _objectSpread from "/builds/huggg/sangria/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import { translateObject } from '@huggg/bar-staff';
import { omit, prop, propOr } from 'ramda';
import { urls } from '../config.js';
import { throttle } from '../utils/promise-utils';
import withAxios from '../utils/with-axios';
import { mapById } from '../utils/find';
import getParams from '../utils/getParams';
import v3Generic from './v3-generic';
import { brandMap, paginatedResponseMap, productMap, searchTagMap } from '../translationMaps';
var DEFAULT_PAGE = 1;
var DEFAULT_PER_PAGE = 20;
var DEFAULT_EMBED = ['products', 'consolidated_products', 'stores'];
var DEFAULT_FEATURED_EMBED = ['brand.products', 'brands', 'brand.consolidated_products', 'brand.stores'];
function formatBrand(brand, embedded) {
  var translatedBrand = translateObject(brandMap, brand);
  var products = mapById(propOr([], 'products', embedded), propOr([], 'products', brand)).map(function (product) {
    var formattedProduct = translateObject(productMap, product);
    var searchTags = mapById(propOr([], 'product-tags', embedded), propOr([], 'searchTags', formattedProduct));
    var formattedSearchTags = searchTags.map(function (searchTag) {
      return translateObject(searchTagMap, searchTag);
    });
    return _objectSpread(_objectSpread({}, formattedProduct), {}, {
      searchTags: formattedSearchTags
    });
  });
  var stores = mapById(propOr([], 'stores', embedded), propOr([], 'stores', brand));
  if (products.length) {
    translatedBrand.products = products;
  }
  if (stores.length) {
    translatedBrand.stores = stores;
  }
  return translatedBrand;
}
function formatAllResponse(data) {
  var translated = translateObject(paginatedResponseMap, data);
  var embedded = translated.embedded;
  if (translated.data && translated.data.length) {
    translated.data = translated.data.map(function (brand) {
      return formatBrand(brand, embedded);
    });
  }
  return omit(['embedded'], translated);
}
function fetch($axios) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var defaultParams = {
    page: DEFAULT_PAGE,
    per_page: DEFAULT_PER_PAGE,
    embed: DEFAULT_EMBED,
    platform: 'app'
  };
  var params = getParams(options, defaultParams);
  return $axios.get(urls.apiV2('/brands'), {
    params: params
  }).then(prop('data')).then(formatAllResponse);
}

/**
 * Takes an array of brands which the user can view, and filters out
 * any which are not purchaseable.
 *
 * @param {array} visibleIds
 * @returns
 */
var purchasePermissions = function purchasePermissions(axios, visibleIds) {
  return axios.post(urls.apiV2('/permissions/apply'), {
    permissionType: 'brand-purchase',
    resourceIds: visibleIds
  }).then(prop('data'));
};
var featured = throttle(function (axios) {
  var embed = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : DEFAULT_FEATURED_EMBED;
  return axios.get(urls.apiV2('/brands/featured'), {
    params: {
      embed: embed,
      platform: 'app'
    }
  }).then(prop('data'));
});
function byId($axios, ids) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var isValidArray = ids && Array.isArray(ids);
  if (!isValidArray) {
    throw new Error('Prop `ids` is required to be an array in `brands.byId`.');
  }
  return fetch($axios, _objectSpread(_objectSpread({}, options), {}, {
    id: ids
  }));
}
var terms = function terms(axios, id) {
  return axios.get(urls.apiV2("/brands/".concat(id, "/terms"))).then(prop('data'));
};
var merchantTerms = function merchantTerms(axios, id) {
  return axios.get(urls.apiV2("/brands/".concat(id, "/merchant-terms"))).then(prop('data'));
};
var howTo = function howTo(axios, id) {
  return axios.get(urls.apiV2("/brands/".concat(id, "/how-to"))).then(prop('data'));
};
var _v3Generic = v3Generic('brands', 'sql'),
  search = _v3Generic.search,
  single = _v3Generic.single;

/**
 * `fetch()` makes a request for a single page of brands. This will default to
 * the first page, unless page is passed in. An option is also provided for
 * perPage, which can be used to specify the number of results returned. If not
 * set, this will use the API's default which will be returned in the response.
 *
 * `featured()` makes a request for current featured brands. This will default
 * to the first page, unless page is passed in. An option is also provided for
 * perPage, which can be used to specify the number of results returned. If not
 * set, this will use the API's default which will be returned in the response.
 *
 * `byId()` makes a request for specified brands. Response is then similar to
 * fetch and featured.
 *
 * `terms(id)` returns the redemption terms and conditions for a given brand id.
 *
 * `merchantTerms(id)` returns the merchant terms and conditions for a given brand id.
 *
 * `howTo(id)` returns the terms and conditions for a given brand id.
 */
export default {
  fetch: withAxios(fetch),
  featured: withAxios(featured),
  byId: withAxios(byId),
  terms: withAxios(terms),
  merchantTerms: withAxios(merchantTerms),
  howTo: withAxios(howTo),
  purchasePermissions: withAxios(purchasePermissions),
  // new V3 endpoints!
  search: withAxios(search),
  single: withAxios(single)
};